<template>
  <IndexPageSection
    :link-string="'一覧へ'"
    :link-url="'/card_designs'"
    :need-to-move-link-to-bottom="false"
    :section-name="'card-design'"
    :title="'カードデザインから探す'"
    @click-link="onClickSectionHeaderLink"
  >
    <div class="card-design__items">
      <div v-if="isCardDesignLoading" class="card-design-loading">
        <SmallLoading />
      </div>
      <div v-else>
        <CardDesignArea :card-designs="cardDesigns" />
      </div>
    </div>
  </IndexPageSection>
</template>
<script>
import IndexPageSection from './IndexPageSection.vue'
import SmallLoading from '../../../atoms/loadings/SmallLoading.vue'
import CardDesignArea from './card_designs/CardDesignArea.vue'
import axios from 'axios'
export default {
  components: { IndexPageSection, SmallLoading, CardDesignArea },
  data() {
    return {
      isCardDesignLoading: false,
      cardDesigns: []
    }
  },
  mounted() {
    this.getCardDesigns()
  },
  methods: {
    onClickSectionHeaderLink() {
      dataLayer.push({
        event: 'click_top__card_design_list'
      })
    },
    async getCardDesigns() {
      this.isCardDesignLoading = true
      try {
        const res = await axios.get('/api/v1/pickup/card_designs/feature')
        this.cardDesigns = res.data.data.map(cardDesign => {
          return {
            id: cardDesign.attributes.id,
            imageUrl: cardDesign.attributes.image_url,
            imageBoxUrl: cardDesign.attributes.image_box_url
          }
        })
        this.isCardDesignLoading = false
      } catch (error) {
        // TODO: Rails 側でエラーが発生した際にフロント側でどのような処理をするかを検討し、ここに実装する
        this.isCardDesignLoading = false
        if (
          !error.response ||
          !error.response.status ||
          !error.response.statusText
        ) {
          console.log(`Error :${error}`)
          return
        }
        const { status, statusText } = error.response
        console.log(`Error! HTTP Status: ${status} ${statusText}`)
        const errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
        console.log(`Error message: ${errorMessage}`)
      }
    }
  }
}
</script>
